import { Handover } from '@lmc/ts-common'
import * as types from '../common/types'

export const setHoursVisible = (hours: number) => ({
  type: types.SET_HOURS_VISIBLE,
  hours,
})

export const setHistoryDateRange = (historyDateRange: [Date, Date]) => ({
  type: types.SET_HISTORY_DATE_RANGE,
  historyDateRange,
})

export const setCurrentHandover = (data: Handover) => ({
  data,
  type: types.SET_CURRENT_HANDOVER,
})

export const setHandoverHistory = (data: null | Handover | Handover[]) => ({
  data,
  type: types.SET_HANDOVER_HISTORY,
})

export const setHandoverLogsAndNotes = (handover: Handover) => ({
  type: types.SET_LOGS_AND_NOTES,
  payload: handover,
})
